import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/government-alignment/components/GovernmentAlignmentInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
